import { render, staticRenderFns } from "./CompanyDataPage.vue?vue&type=template&id=15550f5e&"
import script from "./CompanyDataPage.vue?vue&type=script&lang=js&"
export * from "./CompanyDataPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports